import React, { useState, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router';
import ManageTickets from './ManageTickets';
import TicketDetails from './TicketDetails';
import { Content, PageWithHeader } from '@backstage/core-components';
import { DevxBreadCrumb } from '../../common/BreadcrumbsNav/DevxBreadCrumb';

const ManagePermitBuild = () => {
  const location = useLocation();
  const headerTitle = 'Manage Permit Build';

  const header = {
    title: 'Manage Permit Build',
    subTitleRoutes: [
      {
        type: 'link',
        text: 'Home',
        link: '/',
      },
      {
        type: 'link',
        text: 'Manage Permit Build',
        link: '/manage-permit-build',
      },
    ],
  };

  const [breadCrumb, setBreadCrumb] = useState(header);

  const ieBreadCrumbs = () => {
    const askQuestion = location.pathname.includes('/manage-permit-build/');

    let title = header.title;
    let subTitleRoutes = header.subTitleRoutes;
    let objToInsert = null;
    if (askQuestion) {
      objToInsert = {
        type: 'text',
        text: 'Edit Ticket',
        link: '',
      };
    }
    if (objToInsert !== null)
      subTitleRoutes = [...header.subTitleRoutes, objToInsert];
    else {
      subTitleRoutes[1].type = 'text';
    }

    setBreadCrumb({
      title,
      subTitleRoutes,
    });
  };

  useEffect(() => {
    ieBreadCrumbs();
  }, [location]);

  return (
    <PageWithHeader
      themeId="home"
      pageTitleOverride={breadCrumb?.title}
      subtitle={<DevxBreadCrumb routes={breadCrumb?.subTitleRoutes} />}
      title={undefined}
    >
      <Routes>
        <Route
          path="/"
          element={
            <Content>
              <ManageTickets />
            </Content>
          }
        />
        <Route
          path="/:ticketId"
          element={
            <Content noPadding>
              <TicketDetails />
            </Content>
          }
        />
      </Routes>
    </PageWithHeader>
  );
};

export default ManagePermitBuild;
